import PropTypes from "prop-types";
import React, { useState } from "react";

const Phase = ({ PhaseList, PhaseNum, jump }) => {
    return (
        <div className="flex make__phase">
            {PhaseList.map((i, key) => (
                <React.Fragment key={key}>
                    <div
                        className="make__phase--box cursor-pointer"
                        data-tut={
                            key === 0
                                ? "reactour__start"
                                : key === 1
                                ? "reactour__secondphaze"
                                : key === 2
                                ? "reactour__Thirdphaze"
                                : "reactour__Forthphaze"
                        }
                        onClick={() => {
                            jump(i.PhaseNumber);
                        }}
                    >
                        <p
                            style={
                                PhaseNum >= i.PhaseNumber
                                    ? { opacity: 1 }
                                    : null
                            }
                        >
                            {i.phaseName}
                        </p>
                        <div
                            className="make__phase-circle"
                            style={
                                PhaseNum >= i.PhaseNumber
                                    ? { opacity: "1" }
                                    : { opacity: "0.3" }
                            }
                        >
                            {i.phaseicon}
                        </div>
                    </div>
                    <div
                        className={`make__phase-line ${
                            PhaseNum > i.PhaseNumber
                                ? "make__phase-line-active "
                                : null
                        } `}
                    ></div>
                </React.Fragment>
            ))}
        </div>
    );
};

Phase.propTypes = {
    PhaseList: PropTypes.array,
};

export default Phase;
